module.exports = {
    ICON_FONT_STYLE: {},
}